import request from "@/utils/request";
import plaintextrequest from "@/utils/plaintextrequest";

export function welfareTreasureGameLists(data) {
  return request({
    url: "/game/welfareTreasureGameLists",
    method: "post",
    data,
  });
}

export function welfareTreasureGameInfo(data) {
  return request({
    url: "/game/welfareTreasureGameInfo",
    method: "post",
    data,
  });
}


export function welfareTreasureExchange(data) {
  return request({
    url: "/game/welfareTreasureExchange",
    method: "post",
    data,
  });
}

// 搜索游戏
export function welfareTreasureGameSearchLists(data) {
  return request({
    url: "/game/welfareTreasureGameSearchLists",
    method: "post",
    data,
  });
}

//兑换记录
export function welfareTreasureUserList(data) {
  return request({
    url: "/game/welfareTreasureUserList",
    method: "post",
    data,
  });
}




